import React, { useState, useEffect, useRef, useContext } from "react";
import { HelpButton } from "./common/HelpButton";
import {
	isLandscape,
	subscribeToLandscapeChange,
	unsubscribeFromLandscapeChange,
} from "../services/mobileService";
import { isOnChartScreen } from "../services/summaryReportsService";
import { DiseaseGroupContext } from "../contexts/diseaseGroupContext";
import { BgColorToTextColorMapFunc } from "../CodesToColorMap";

export const DashboardHeader = ({ title, subtitle, onHelpClick, demoMode }) => {
	const [hide, setHide] = useState(false);

	const { theme } = useContext(DiseaseGroupContext);

	const handleLandscapeChange = (value) => {
		if (isMounted.current === true) {
			setHide(value && isOnChartScreen());
		}
	};

	const isMounted = useRef(false);

	useEffect(() => {
		isMounted.current = true;

		const subscriptionName = "DashboardHeader";
		subscribeToLandscapeChange(subscriptionName, handleLandscapeChange);

		isLandscape().then(handleLandscapeChange);

		return () => {
			isMounted.current = false;
			unsubscribeFromLandscapeChange(subscriptionName);
		};
	}, []);

	if (hide === true) {
		return null;
	}
	
	return (
		<div className={`${theme.primary().bg()} rounded-b-xl p-safeAreaTop`}>
			<div className={`flex justify-between items-end px-6 py-2.5 lg:py-5 text-white`}>
				<div className={"flex flex-col"}>
					<div className={"inline-flex items-center"}>
						<h1 className={"text-lg font-bold leading-3 flex content-center"}>
							<span>{title}</span>
						</h1>
						{demoMode && (
							<span className={"opacity-70 leading-3 font-bold pl-1.5"}>
								(Demo)
							</span>
						)}
					</div>
					<div>
						<span className={"opacity-70 leading-3 text-sm font-bold"}>
							{subtitle}
						</span>
					</div>
				</div>
				{onHelpClick && <HelpButton onClick={onHelpClick} variant={"light"} />}
			</div>
		</div>
	);
};
